import { useContext, useEffect, useState } from "react";
import "./customer-home-checkout.styles.scss";
import { CustomerOrderContext } from "../../../contexts/customerOrder.context";
import RestaurantLoader from "../../restaurant/restaurant-loader/restaurant-loader.component";
import { LoaderContext } from "../../../contexts/loader.context";
const CustomerHomeCheckout = () => {
  const [orderPlacedClass, setOrderPlacedClass] = useState("chc-status-ball");
  const [preparingClass, setPreparingClass] = useState("chc-status-ball");
  const [doneClass, setDoneClass] = useState("chc-status-ball");
  const {
    customerOrderContext,
    orderTotal,
    orderType,
    setTableNumber,
    tableNumber,
    sendToKitchenFunction,
    orderMessage,
    setOrderMessage,
    customerEmail,
    setCustomerEmail,
    orderStatus,
  } = useContext(CustomerOrderContext);

  useEffect(() => {
    if (orderStatus === "Order Placed") {
      setOrderPlacedClass("chc-status-ball-green");
    } else if (orderStatus === "Preparing") {
      setOrderPlacedClass("chc-status-ball-green");
      setPreparingClass("chc-status-ball-green");
    } else if (orderStatus === "Done") {
      setOrderPlacedClass("chc-status-ball-green");
      setPreparingClass("chc-status-ball-green");
      setDoneClass("chc-status-ball-green");
    }
  }, [orderStatus]);
  const handleChange = (event) => {
    const { value } = event.target;
    setTableNumber(value);
  };
  const handleEmailChange = (event) => {
    const { value } = event.target;
    setCustomerEmail(value);
  };
  const handleOrderMessage = (event) => {
    const { value } = event.target;
    setOrderMessage(value);
  };
  const { setLoaderClass } = useContext(LoaderContext);
  const handleClick = () => {
    if (orderType === "tableside" && tableNumber === "") {
      console.log("Choose a table number");
    } else {
      sendToKitchenFunction(setLoaderClass);
    }
  };
  return (
    <div className="chc-container">
      <RestaurantLoader />
      {orderType === "tableside" && (
        <div className="chc-tablenumber-box">
          <input
            type="text"
            value={tableNumber}
            onChange={handleChange}
            placeholder="Table Number"
            className="chc-tablenumber-input"
          />
        </div>
      )}
      <div className="chc-email-box">
        <input
          type="text"
          value={customerEmail}
          onChange={handleEmailChange}
          placeholder="Customer Email (For loyalty points)"
          className="chc-email-input"
        />
      </div>
      <div className="chc-order-box">
        <div className="chc-order-box-title">
          <span className="chc-order-title">Item Details</span>
          <span className="chc-order-title">Price</span>
        </div>
        {Object.keys(customerOrderContext).map((index) => {
          const tempObject = customerOrderContext[index];
          return (
            <div key={index} className="chc-box-item">
              <div className="chc-box-item-details">
                <span className="chc-box-item-name">{index}</span>
                <span className="chc-box-item-count">
                  x {tempObject["itemCount"]}
                </span>
              </div>
              <span className="chc-box-item-price">
                {tempObject["itemTotal"]}
              </span>
            </div>
          );
        })}
        <div className="chc-box-total">
          <span className="chc-box-total-title">Total</span>
          <span className="chc-box-total-value">{orderTotal}</span>
        </div>
      </div>
      <div className="chc-message-container">
        <textarea
          className="chc-message-textarea"
          placeholder="Enter Instructions (optional)"
          value={orderMessage}
          onChange={handleOrderMessage}
        ></textarea>
      </div>
      <div className="chc-send-button-container">
        <button className="chc-send-button" onClick={handleClick}>
          Send to kitchen
        </button>
      </div>
      <div className="chc-status-container">
        <div className="chc-status">
          <div className={orderPlacedClass}></div>
          <span className="chc-status-title">Order Placed</span>
        </div>
        <div className="chc-status">
          <div className={preparingClass}></div>
          <span className="chc-status-title">Preparing</span>
        </div>
        <div className="chc-status">
          <div className={doneClass}></div>
          <span className="chc-status-title">Done</span>
        </div>
      </div>
    </div>
  );
};
export default CustomerHomeCheckout;
